export enum ApplicationTypeCode {
  DirectCredit = 'DC',
  InternationalCreditConversion = 'ICC',
  PRA = 'PRA',
}
